export default "__VITE_ASSET__5f0d7ef1__"